<div class="audit-wrapper">
  <!-- Header -->
  <div class="audit-header">
    <button class="back-btn" (click)="goBack()">
      <span class="material-icons">arrow_back</span>
    </button>
    <h1 class="header-title">Session Audit Trail</h1>
    <div class="user-info" *ngIf="userDetails">
      <span class="user-name">{{ userDetails.firstName }} {{ userDetails.lastName }}</span>
      <span class="user-email">{{ userDetails.email }}</span>
    </div>
  </div>

  <div class="audit-grid">
    <!-- LEFT COLUMN -->
    <div class="left-column">
      <!-- USER PROFILE CARD -->
      <div class="card profile-card">
        <div class="card-header" (click)="toggleProfileCard()">
          <div class="card-title">
            <span class="material-icons card-icon">person</span>
            <span>User Profile</span>
          </div>
          <span class="material-icons toggle-icon" [class.rotated]="isProfileOpen">expand_more</span>
        </div>
        
        <div class="card-body" *ngIf="isProfileOpen">
          <ng-container *ngIf="userDetails">
            <div class="profile-header">
              <div class="avatar-container">
                <ng-container *ngIf="userDetails.avatarUrl; else fallbackAvatar">
                  <img [src]="userDetails.avatarUrl" class="avatar" alt="User avatar" />
                </ng-container>
                <ng-template #fallbackAvatar>
                  <div class="avatar fallback">
                    {{ userDetails.email ? (userDetails.email[0] | uppercase) : '?' }}
                  </div>
                </ng-template>
              </div>
              <div class="profile-info">
                <h3 class="user-name">{{ userDetails.name || '-' }}</h3>
                <p class="user-email">{{ userDetails.email || '-' }}</p>
              </div>
            </div>

            <div class="meta-grid">
              <!-- <div class="meta-item">
                <span class="material-icons meta-icon">devices</span>
                <div class="meta-content">
                  <span class="meta-label">Device</span>
                  <span class="meta-value">{{ userDetails.device || '-' }}</span>
                </div>
              </div> -->
              <div class="meta-item">
                <span class="material-icons meta-icon">language</span>
                <div class="meta-content">
                  <span class="meta-label">IP Address</span>
                  <div class="meta-value ip-address-value" 
                        [matTooltip]="userDetails.ipAddress" 
                        matTooltipPosition="above"
                        (click)="copyIpAddress(userDetails.ipAddress)">
                    <span class="ip-text">{{ userDetails.ipAddress || '-' }}</span>
                    <span class="material-icons copy-icon"
                          *ngIf="userDetails.ipAddress"
                          [class.animate-copied]="copiedIp === userDetails.ipAddress">
                      {{ copiedIp === userDetails.ipAddress ? 'check_circle' : 'content_copy' }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="meta-item">
                <span class="material-icons meta-icon">location_on</span>
                <div class="meta-content">
                  <span class="meta-label">Location</span>
                  <span class="meta-value">{{ userDetails.location || '-' }}</span>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- SESSION SUMMARY CARD -->
      <!-- <div class="card summary-card">
        <div class="card-header" (click)="toggleSessionSummary()">
          <div class="card-title">
            <span class="material-icons card-icon">insights</span>
            <span>Session Overview</span>
          </div>
          <span class="material-icons toggle-icon" [class.rotated]="isSummaryOpen">expand_more</span>
        </div>

        <div class="card-body" *ngIf="isSummaryOpen">
          <div class="stats-grid">
            <div class="stat-box">
              <span class="stat-number">{{ logChain.length }}</span>
              <span class="stat-label">Total Logs</span>
            </div>
            <div class="stat-box">
              <span class="stat-number">{{ calculateSessionDuration() }}</span>
              <span class="stat-label">Duration</span>
            </div>
          </div>

          <div class="metadata-list">
            <div class="metadata-row">
              <span class="metadata-label">Login Time</span>
              <span class="metadata-value">{{ user?.loginTime | date:'medium' }}</span>
            </div>
            <div class="metadata-row">
              <span class="metadata-label">Logout Time</span>
              <span class="metadata-value">{{ user?.logoutTime ? (user.logoutTime | date:'medium') : 'Active Session' }}</span>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <!-- RIGHT COLUMN - ACTIVITY TIMELINE -->
    <div class="right-column">
      <div class="activity-card">
        <!-- Timeline Header -->
        <div class="timeline-header">
          <div class="header-title">
            <h2>Activity Timeline</h2>
            <span class="log-count">{{ filteredLogChain.length }} entries</span>
          </div>
          <div class="header-actions">
            <div class="search-wrapper">
              <span class="material-icons search-icon">search</span>
              <input 
                type="text" 
                [(ngModel)]="searchTerm" 
                (input)="applySearch()"
                placeholder="Search logs..."
                class="search-input"
              />
            </div>
            <button class="action-btn" (click)="downloadLogs()" title="Export logs">
              <span class="material-icons">download</span>
            </button>
          </div>
        </div>

        <!-- Timeline Content -->
        <div class="timeline-content">
          <div class="timeline-list" *ngIf="filteredLogChain.length > 0">
            <div 
              class="timeline-item" 
              *ngFor="let log of filteredLogChain; let i = index"
              [class.expanded]="expandedLog === log.id"
            >
              <!-- Timeline Indicator -->
              <div class="timeline-indicator">
                <div class="indicator-dot" [ngClass]="getLogTypeClass(log)">
                  <span class="material-icons">{{ getLogIcon(log) }}</span>
                </div>
                <div class="indicator-line" *ngIf="i < filteredLogChain.length - 1"></div>
              </div>

              <!-- Timeline Card -->
              <div class="timeline-card">
                <div class="card-top" (click)="toggleLogExpansion(log)">
                  <div class="card-info">
                    <div class="card-type">
                      <span class="type-badge" [ngClass]="getLogTypeClass(log)">{{ getLogType(log) }}</span>
                      <span class="client-badge" *ngIf="log.presentClient">{{ log.presentClient }}</span>
                    </div>
                    <h4 class="card-action">{{ getLogAction(log) }}</h4>
                    <div class="card-time">
                      <span class="material-icons time-icon">schedule</span>
                      <span>{{ formatTimestamp(log.createdTime) }}</span>
                      <span class="time-ago">{{ getTimeAgo(log.createdTime) }}</span>
                    </div>
                  </div>
                  <span class="material-icons expand-arrow" [class.rotated]="expandedLog === log.id">expand_more</span>
                </div>

                <!-- Collapsed Preview -->
                <div class="card-preview" *ngIf="expandedLog !== log.id">
                  <p>{{ getLogSummary(log) }}</p>
                </div>

                <!-- Expanded Details -->
                <div class="card-details" *ngIf="expandedLog === log.id">
                  <!-- Basic Info Section -->
                  <div class="detail-section" *ngIf="log.consultantName || log.presentRole || log.interviewingRole || log.interviewType">
                    <h5 class="section-title">Basic Information</h5>
                    <div class="info-grid">
                      <div class="info-item" *ngIf="log.consultantName">
                        <span class="info-label">Consultant</span>
                        <span class="info-value">{{ log.consultantName }}</span>
                      </div>
                      <div class="info-item" *ngIf="log.presentRole">
                        <span class="info-label">Current Role</span>
                        <span class="info-value">{{ log.presentRole }}</span>
                      </div>
                      <div class="info-item" *ngIf="log.interviewingRole">
                        <span class="info-label">Target Role</span>
                        <span class="info-value highlight">{{ log.interviewingRole }}</span>
                      </div>
                      <div class="info-item" *ngIf="log.interviewType">
                        <span class="info-label">Interview Type</span>
                        <span class="info-value">{{ log.interviewType }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- Client Info Section -->
                  <div class="detail-section" *ngIf="log.presentClient || log.previousClient || log.interviewingClient">
                    <h5 class="section-title">Client Information</h5>
                    <div class="client-chips">
                      <div class="client-chip" *ngIf="log.presentClient">
                        <span class="chip-label">Current</span>
                        <span class="chip-value">{{ log.presentClient }}</span>
                      </div>
                      <div class="client-chip" *ngIf="log.previousClient">
                        <span class="chip-label">Previous</span>
                        <span class="chip-value">{{ log.previousClient }}</span>
                      </div>
                      <div class="client-chip highlight" *ngIf="log.interviewingClient">
                        <span class="chip-label">Interviewing For</span>
                        <span class="chip-value">{{ log.interviewingClient }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- User Message Section -->
                  <div class="detail-section" *ngIf="log.userMessageText">
                    <h5 class="section-title">User Message</h5>
                    <div class="message-card question">
                      <div class="message-header">
                        <span class="message-label">Question</span>
                        <span class="message-meta">{{ log.userMessageText.length }} chars</span>
                      </div>
                      <p class="message-text">{{ log.userMessageText }}</p>
                      <div class="prompt-id-row" *ngIf="log.promptId">
                        <span class="prompt-label">Prompt ID:</span>
                        <code class="prompt-code">{{ log.promptId }}</code>
                      </div>
                    </div>
                  </div>

                  <!-- AI Answer Section -->
                  <div class="detail-section" *ngIf="log.answerText">
                    <h5 class="section-title">AI Response</h5>
                    <div class="message-card answer">
                      <div class="message-header">
                        <span class="message-label">Answer</span>
                        <span class="message-meta">{{ log.answerText.length }} chars</span>
                      </div>
                      <p class="message-text">{{ log.answerText }}</p>
                    </div>
                  </div>

                  <!-- Prompt Configuration Section -->
                  <div class="detail-section" *ngIf="log.prompt">
                    <h5 class="section-title">Prompt Configuration</h5>
                    <div class="config-grid">
                      <div class="config-item">
                        <span class="config-label">Prompt ID</span>
                        <code class="config-value">{{ log.prompt.id || 'N/A' }}</code>
                      </div>
                      <div class="config-item">
                        <span class="config-label">Name</span>
                        <span class="config-value">{{ log.prompt.name || 'Unnamed' }}</span>
                      </div>
                      <div class="config-item full-width">
                        <span class="config-label">Job Description</span>
                        <span class="config-value">{{ log.prompt.jobDescription || 'Not specified' }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Empty State -->
          <div class="empty-state" *ngIf="filteredLogChain.length === 0">
            <span class="material-icons empty-icon">search_off</span>
            <h3>No logs found</h3>
            <p>Try adjusting your search criteria</p>
            <button class="reset-btn" (click)="resetFilters()">Reset Filters</button>
          </div>
        </div>

        <!-- Timeline Footer -->
        <div class="timeline-footer">
          <span class="footer-stat">Showing {{ filteredLogChain.length }} of {{ logChain.length }} logs</span>
        </div>
      </div>
    </div>
  </div>
</div>